export default "__VITE_ASSET__CVlA5fAG__"